// extracted by mini-css-extract-plugin
module.exports = {"ListMapWrapper":"TrainDetailsPage_ListMapWrapper__SrL4N","HeaderWrapper":"TrainDetailsPage_HeaderWrapper__lhFk4"};